<div class="container" *ngIf="searchEnabled && (isXsOrSm$ | async)">
    <div class="row">
        <div class="col-12">
            <ng-template *ngTemplateOutlet="searchForm"></ng-template>
        </div>
    </div>
</div>

<ds-search-charts *ngIf="showCharts"
                  [configuration]="currentConfiguration$"
                  [collapseChart]="collapseCharts"
                  [filters]="chartFiltersRD$.asObservable()"
                  [inPlaceSearch]="inPlaceSearch"
                  [refreshFilters]="refreshFilters"
                  [scope]="scope"
                  [showChartsToggle]="showChartsToggle"></ds-search-charts>

<div *ngIf="!showSidebar && (initialized$ | async)">
    <ng-template *ngTemplateOutlet="searchContent"></ng-template>
</div>

<ds-page-with-sidebar *ngIf="showSidebar && (initialized$ | async)"
                      [collapseSidebar]="collapseFilters"
                      [id]="'search-page'"
                      [sidebarContent]="sidebarContent"
                      [sideBarWidth]="sideBarWidth">
    <ng-template *ngTemplateOutlet="searchContent"></ng-template>
</ds-page-with-sidebar>

<ng-template #searchContent>
    <div class="row">
        <div class="col-12" *ngIf="(isXsOrSm$ | async) !== true">
            <ng-container *ngIf="searchEnabled">
                <ng-template *ngTemplateOutlet="searchForm"></ng-template>
            </ng-container>
            <ng-content select="[additionalSearchOptions]"></ng-content>
            <ng-content select="[bulkActions]"></ng-content>
        </div>
        <div id="search-content" class="col-12">
            <div class="d-block d-md-none search-controls clearfix">
                <ds-view-mode-switch *ngIf="inPlaceSearch && showViewModes"
                                     [viewModeList]="viewModeList"
                                     [inPlaceSearch]="inPlaceSearch"></ds-view-mode-switch>
                <button (click)="openSidebar()"
                        aria-controls="#search-body"
                        class="btn btn-outline-primary float-right open-sidebar">
                  <i class="fas fa-sliders"></i> {{"search.sidebar.open" | translate}}
                </button>
            </div>
            <ng-content select="[searchContentTop]"></ng-content>
            <ds-search-results *ngIf="inPlaceSearch"
                                      [searchResults]="resultsRD$ | async"
                                      [searchConfig]="searchOptions$ | async"
                                      [configuration]="(currentConfiguration$ | async)"
                                      [disableHeader]="!searchEnabled"
                                      [linkType]="linkType"
                                      [context]="(currentContext$ | async)"
                                      [customData]="customData"
                                      [searchResultNotice]="searchResultNotice"
                                      [searchResultNoticeType]="searchResultNoticeType"
                                      [selectable]="selectable"
                                      [selectionConfig]="selectionConfig"
                                      [showCsvExport]="showCsvExport"
                                      [showLabel]="showLabel"
                                      [showMetrics]="showMetrics"
                                      [showSearchResultNotice]="showSearchResultNotice"
                                      [showWorkflowStatistics]="showWorkflowStatistics"
                                      [showThumbnails]="showThumbnails"
                                      [showCorrection]="showCorrection"
                                      (contentChange)="onContentChange($event)"
                                      (customEvent)="customEvent.emit($event)"
                                      (deselectObject)="deselectObject.emit($event)"
                                      (selectObject)="selectObject.emit($event)"></ds-search-results>
        </div>
    </div>
</ng-template>

<ng-template #sidebarContent>
    <ds-search-sidebar id="search-sidebar" *ngIf="(isXsOrSm$ | async) !== true"
                       [configurationList]="configurationList"
                       [configuration]="(currentConfiguration$ | async)"
                       [currentScope]="(currentScope$ | async)"
                       [filters]="filtersRD$.asObservable()"
                       [refreshFilters]="refreshFilters"
                       [resultCount]="(resultsRD$ | async)?.payload?.totalElements"
                       [searchOptions]="(searchOptions$ | async)"
                       [sortOptionsList]="(sortOptionsList$ | async)"
                       [currentSortOption]="(currentSortOptions$ | async)"
                       [inPlaceSearch]="inPlaceSearch"
                       [viewModeList]="viewModeList"
                       [showViewModes]="showViewModes"
                       (changeConfiguration)="changeContext($event.context)"
                       (changeViewMode)="changeViewMode()"></ds-search-sidebar>
    <ds-search-sidebar id="search-sidebar-sm" *ngIf="(isXsOrSm$ | async)"
                       [configurationList]="configurationList"
                       [configuration]="(currentConfiguration$ | async)"
                       [currentScope]="(currentScope$ | async)"
                       [filters]="filtersRD$.asObservable()"
                       [refreshFilters]="refreshFilters"
                       [resultCount]="(resultsRD$ | async)?.payload?.totalElements"
                       [searchOptions]="(searchOptions$ | async)"
                       [sortOptionsList]="(sortOptionsList$ | async)"
                       [currentSortOption]="(currentSortOptions$ | async)"
                       [inPlaceSearch]="inPlaceSearch"
                       [viewModeList]="viewModeList"
                       [showViewModes]="showViewModes"
                       (toggleSidebar)="closeSidebar()"
                       (changeConfiguration)="changeContext($event.context)"
                       (changeViewMode)="changeViewMode()">
    </ds-search-sidebar>
</ng-template>

<ng-template #searchForm>
    <div class="d-flex flex-wrap flex-xl-nowrap search-form-flex-wrapper" [class.justify-content-end]="!searchEnabled">
        <div *ngIf="(isXsOrSm$ | async) !== true && showFilterToggle && showSidebar">
            <button class="btn btn-outline-secondary"
                    ngbTooltip="{{'search.sidebar.show.hide.filters.tooltip' | translate}}"
                    (click)="toggleSidebar()">
                <span class="d-flex align-items-center">
                    <i class="fa fa-filter mr-2"></i>
                    {{"search.sidebar.show.hide" | translate}}</span>
            </button>
        </div>
        <ds-search-form id="search-form" class="flex-grow-1"
                        [query]="(searchOptions$ | async)?.query"
                        [scope]="(searchOptions$ | async)?.scope"
                        [hideScopeInUrl]="hideScopeInUrl"
                        [currentUrl]="searchLink"
                        [showScopeSelector]="showScopeSelector"
                        [inPlaceSearch]="inPlaceSearch"
                        [searchPlaceholder]="searchFormPlaceholder | translate">
        </ds-search-form>
        <ng-content select="[additionalSearchFormOptions]"></ng-content>
        <ds-item-export-modal-launcher [searchOptions$]="searchOptions$" *ngIf="showExport"></ds-item-export-modal-launcher>
    </div>
    <div class="row my-3 my-md-1">
        <div class="labels col-12">
            <ds-search-labels [inPlaceSearch]="inPlaceSearch">
            </ds-search-labels>
        </div>
    </div>
</ng-template>
